import { useState, useCallback, useMemo } from 'react';
import ConfirmDialog from '../components/ConfirmDialog';

export function useDialog() {
  const [state, setState] = useState(null);

  const close = useCallback(() => setState(null), []);

  const alert = useCallback((title, message, opts = {}) => {
    return new Promise((resolve) => {
      setState({
        mode: 'alert',
        title: title || 'Hinweis',
        message: message || '',
        confirmLabel: opts.confirmLabel,
        variant: opts.variant || 'primary',
        onResolve: () => { close(); resolve(true); },
      });
    });
  }, [close]);

  const confirm = useCallback((title, message, opts = {}) => {
    return new Promise((resolve) => {
      setState({
        mode: 'confirm',
        title: title || 'Bestätigen',
        message: message || '',
        confirmLabel: opts.confirmLabel,
        cancelLabel: opts.cancelLabel,
        variant: opts.variant || 'primary',
        onResolve: (val) => { close(); resolve(val); },
      });
    });
  }, [close]);

  const element = useMemo(() => {
    if (!state) return null;
    return (
      <ConfirmDialog
        open
        title={state.title}
        message={state.message}
        confirmLabel={state.confirmLabel}
        cancelLabel={state.cancelLabel}
        variant={state.variant}
        infoOnly={state.mode === 'alert'}
        onConfirm={() => state.onResolve(true)}
        onCancel={() => state.onResolve(false)}
      />
    );
  }, [state]);

  return { alert, confirm, element };
}

export default useDialog;
